import React from 'react';
import { SearchOptionType, SearchResult, SectionType } from '../../types';
import { TreeViewBaseItem } from '@mui/x-tree-view';
import { useSearchParams } from 'react-router-dom';

interface ILayoutProvider {
  // drawer props
  drawerOpen: boolean;
  setDrawerOpen: (open: boolean) => void;
  drawerVisible: boolean;
  setDrawerVisible: (visible: boolean) => void;
  drawerSections: TreeViewBaseItem<SectionType>[];
  drawerFooter: React.ReactNode;
  drawerContent: React.ReactNode;
  appBarTools: React.ReactNode;
  printMode: boolean;
  printTimeout: number;
  setDrawerContent: (header: React.ReactNode) => void;
  setDrawerSections: (sections: TreeViewBaseItem<SectionType>[]) => void;
  setDrawerFooter: (footer: React.ReactNode) => void;
  searchOptions: SearchOptionType;
  setSearchOptions: (searchOptions: SearchOptionType) => void;
  searchResults: SearchResult[];
  setSearchResults: (searchResults: SearchResult[]) => void;
  setAppBarTools: (tools: React.ReactNode) => void;
  setPrintMode: (visible: boolean) => void;
  // AppBar props
  // appBarTitle: string;
  // setAppBarTitle: (title: string) => void;
}

export const LayoutContext = React.createContext<ILayoutProvider>(null!);

export function LayoutProvider({ children }: { children: React.ReactNode }) {
  const [searchParams] = useSearchParams();
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const [drawerVisible, setDrawerVisible] = React.useState(true);
  const [drawerSections, setDrawerSections] = React.useState<TreeViewBaseItem<SectionType>[]>([]);
  const [drawerContent, setDrawerContent] = React.useState<React.ReactNode>();
  const [drawerFooter, setDrawerFooter] = React.useState<React.ReactNode>();
  const [searchOptions, setSearchOptions] = React.useState<SearchOptionType>({
    visible: false,
    placeholder: 'Search...',
  });
  const [searchResults, setSearchResults] = React.useState<SearchResult[]>([]);
  const [appBarTools, setAppBarTools] = React.useState<React.ReactNode>();
  const print = searchParams.get('print');
  const printTimeout = parseInt(searchParams.get('printTimeout') || "200", 10);
  const [printMode, setPrintMode] = React.useState(print === 'true');

  const value = {
    drawerOpen,
    setDrawerOpen,
    drawerVisible,
    setDrawerVisible,
    drawerSections,
    setDrawerSections,
    drawerContent,
    setDrawerContent,
    drawerFooter,
    setDrawerFooter,
    searchOptions,
    setSearchOptions,
    searchResults,
    setSearchResults,
    appBarTools,
    setAppBarTools,
    printMode,
    setPrintMode,
    printTimeout,
  };

  return <LayoutContext.Provider value={value}>{children}</LayoutContext.Provider>;
}

export function useLayoutContext() {
  return React.useContext(LayoutContext);
}
